module.exports = __webpack_public_path__ + "img/location.303851ec.png";